React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_team_filter')

module.exports = class extends React.Component
  render: t.renderable ->
    { checkedStatus, eventHandlers, item } = @props
    { name, logoHash, displayName } = item

    t.a '.popover-item .u-clearfix',
      href: '#'
      onClick: (e) ->
        e.preventDefault()
        eventHandlers.onClick(item)
    , ->
      if logoHash
        t.img '.popover-item-image', src: [logoDomain, logoHash, '30.png'].join('/')
      else
        t.span '.popover-item-image.icon-lg.icon-organization'

      t.span '.popover-item-name', ->
        t.text displayName

      return unless checkedStatus?

      if checkedStatus.isActive(item)
        t.span '.dash-filter-marker.dash-filter-marker-for-teams .on', ->
          t.icon 'check', { class: 'light' }



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/popover-team-item-component.coffee